export var StoryJobStatus;
(function (StoryJobStatus) {
    StoryJobStatus["PENDING"] = "pending";
    StoryJobStatus["GENERATING_TEXT"] = "generating_text";
    StoryJobStatus["GENERATING_AUDIO"] = "generating_audio";
    StoryJobStatus["UPLOADING"] = "uploading";
    StoryJobStatus["COMPLETED"] = "completed";
    StoryJobStatus["FAILED"] = "failed";
})(StoryJobStatus || (StoryJobStatus = {}));
export function isTranslationJob(input) {
    return input.kind === "translate";
}
//# sourceMappingURL=jobs.js.map